var map = {
	"./a.svg": "9674",
	"./b.svg": "b116",
	"./bigleft1.svg": "0436",
	"./bigleft2.svg": "6b29",
	"./bigright1.svg": "00af",
	"./bigright2.svg": "dbe0",
	"./bigroot.svg": "b386",
	"./blank.svg": "d02e",
	"./c.svg": "0ee2",
	"./div.svg": "2281",
	"./dot.svg": "fbe7",
	"./equal.svg": "f37d",
	"./left1.svg": "82ab",
	"./left2.svg": "f031",
	"./minus.svg": "802e",
	"./n0.svg": "16f4",
	"./n1.svg": "251f",
	"./n2.svg": "a1d9",
	"./n3.svg": "6600",
	"./n4.svg": "10ad",
	"./n5.svg": "d63f",
	"./n6.svg": "b9d8",
	"./n7.svg": "e19d",
	"./n8.svg": "ac92",
	"./n9.svg": "86bd",
	"./plus.svg": "851f",
	"./pm.svg": "ddc5",
	"./right1.svg": "6713",
	"./right2.svg": "7de7",
	"./root.svg": "4e2d",
	"./times.svg": "3cbb",
	"./u2.svg": "a6b1",
	"./u3.svg": "a415",
	"./u4.svg": "82cc",
	"./u5.svg": "5917",
	"./u6.svg": "e09a",
	"./u7.svg": "f182",
	"./u8.svg": "f009",
	"./u9.svg": "759c",
	"./x.svg": "bb2e",
	"./y.svg": "d573",
	"./z.svg": "78ab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d868";